//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Btn from './Btn.vue';

export default {
	name: 'page-overlay',

	components: { Btn: Btn },

	props: {
		show: {
			type: Boolean,
			default: false
		},

		pageScroll: {
			type: Boolean,
			dfault: false
		},

		width: {
			type: Number,
			default: 1080
		},

		autoHeight: {
			type: Boolean,
			default: false
		},

		duration: {
			type: Number,
			default: 200
		}
	},

	computed: {
		scrollbarWidth: function scrollbarWidth() {
			var el = document.createElement("div"),
			    barWidth = 0;

			el.className = "scrollbar-measure";
			el.style.width = '100px';
			el.style.height = '100px';
			el.style.overflow = 'scroll';
			el.style.position = 'absolute';
			el.style.top = '-9999px';

			document.body.appendChild(el);

			barWidth = el.offsetWidth - el.clientWidth;
			document.body.removeChild(el);

			return barWidth;
		},
		pageHasScroll: function pageHasScroll() {
			return document.documentElement.scrollHeight > document.documentElement.clientHeight;
		}
	},

	methods: {
		toggleOffset: function toggleOffset() {
			if (!process.server) {
				if (!this.show) {
					document.documentElement.classList.remove('-has-open-overlay');
					document.documentElement.style.setProperty("--scrollbar-offset", 0);
				} else if (!this.pageScroll && this.pageHasScroll) {
					document.documentElement.classList.add('-has-open-overlay');
					document.documentElement.style.setProperty("--scrollbar-offset", this.scrollbarWidth + 'px');
				}
			}
		}
	},

	mounted: function mounted() {
		this.toggleOffset();
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageOverlay.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageOverlay.vue
// module chunks = 5